import { InfoCircleFill } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { Typography } from 'antd';

import Alert from '@/components/shared/Alert';
import { formatDate } from '@/helpers/formatDate';
import { enStatus } from '@/interfaces/course';
import { coursesApi } from '@/services/course';
import styled, { StyledProp } from '@/styled';

const NotRelesed = ({ className }: StyledProp) => {
  const { hash } = useParams();
  const { data: course } = coursesApi.endpoints.getCourse.useQueryState(hash);

  if (course?.status !== enStatus.NOT_RELEASED) {
    return;
  }

  const messageDate = course?.release_at ? `em ${formatDate(course?.release_at)}` : 'ainda';

  return (
    <Alert
      className={className}
      icon={<InfoCircleFill size={20} />}
      type='error'
      message='Esse curso ainda não está disponível'
      description={
        <Typography.Text>
          Esse curso será liberada {messageDate}. Para mais informações, acesse a aba
          <Typography.Text strong> Falar com o produtor</Typography.Text> na área do curso.
        </Typography.Text>
      }
    />
  );
};

export default styled(NotRelesed)``;
